// Bar block for Owner BI / weekly snapshot: revenue vs previous window, margin, payments, top sellers, stock.
import React from 'react';
import { Coffee } from 'lucide-react';

const eur = (v) => `€${Number(v || 0).toFixed(0)}`;

export const BarRevenueCard = ({ bar, title = 'Bar (last 30 days)' }) => {
  if (!bar) return null;
  const delta = bar.prev_revenue ? Math.round((bar.revenue - bar.prev_revenue) / bar.prev_revenue * 100) : null;
  const top = (bar.top || []).slice(0, 3).map((t) => `${t.qty}× ${t.name}`).join(' · ');
  const pays = Object.entries(bar.by_payment || {}).map(([k, v]) => `${k} ${eur(v)}`).join(' · ');
  return (
    <div className="bg-white rounded-xl border p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="bi-bar-card">
      <div className="w-10 h-10 rounded-lg bg-amber-100 text-amber-700 flex items-center justify-center flex-shrink-0"><Coffee className="w-5 h-5" /></div>
      <div className="flex-1 min-w-0">
        <p className="text-xs uppercase tracking-wide text-slate-500">{title}</p>
        <p className="text-xl font-bold text-slate-900" data-testid="bi-bar-revenue">{eur(bar.revenue)}
          {delta != null && <span className={`ml-2 text-xs font-semibold ${delta >= 0 ? 'text-emerald-600' : 'text-red-600'}`} data-testid="bi-bar-delta">{delta >= 0 ? '+' : ''}{delta}% vs previous</span>}
        </p>
        <p className="text-xs text-slate-500">{bar.tickets} tickets · margin {bar.margin_pct != null ? `${bar.margin_pct}%` : '—'}{pays ? ` · ${pays}` : ''}</p>
        {top && <p className="text-xs text-slate-600 mt-0.5">Top: {top}</p>}
      </div>
      <div className="text-xs text-right text-slate-600 whitespace-nowrap">
        <p>Stock value <b>{eur(bar.stock_value)}</b></p>
        {bar.low_stock > 0 && <p className="text-amber-700 font-semibold" data-testid="bi-bar-low">{bar.low_stock} below threshold</p>}
      </div>
    </div>
  );
};

export default BarRevenueCard;
